export default "__VITE_ASSET__ud4OxKO4__"